import { Form, Button } from "react-bootstrap";
import { KeyboardArrowUp } from "@mui/icons-material";
import { KeyboardArrowDown } from "@mui/icons-material";

interface EditableRowProps {
  record: { id: number; name: string; rank: number; pendingRemoval?: boolean };
  editable: boolean;
  onChange: (newValue: string) => void;
  onToggleRemove: () => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  isFirst: boolean;
  isLast: boolean;
}

const EditableRow = ({
  record,
  editable,
  onChange,
  onToggleRemove,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast,
}: EditableRowProps) => {
  const isRemoving = record.pendingRemoval === true;

  return (
    <div
      className={`d-flex align-items-center mb-2 p-2 fade show ${
        isRemoving ? "bg-danger-subtle opacity-75" : "bg-white"
      }`}
      style={{
        transition: "background-color 0.3s ease, opacity 0.3s ease",
      }}
    >
      <Form.Control
        type="text"
        value={record.name}
        readOnly={!editable || isRemoving}
        className={`me-2 form-control-sm w-75 ${
          !editable ? "bg-light text-muted" : ""
        } ${isRemoving ? "text-decoration-line-through" : ""}`}
        onChange={(e) => onChange(e.target.value)}
      />

      {editable && (
        <>
          <div className="d-flex flex-column me-2">
            <Button
              variant="outline-secondary"
              size="sm"
              className="p-0 mb-1"
              onClick={onMoveUp}
              disabled={isFirst}
            >
              <KeyboardArrowUp fontSize="small"/>
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              className="p-0"
              onClick={onMoveDown}
              disabled={isLast}
            >
              <KeyboardArrowDown fontSize="small" />
            </Button>
          </div>

          <Button
            variant={isRemoving ? "success" : "danger"}
            size="sm"
            onClick={onToggleRemove}
          >
            {isRemoving ? "Annulla rimozione" : "Rimuovi"}
          </Button>
        </>
      )}
    </div>
  );
};

export default EditableRow;